<template>
  <div :class="classObj" class="app-wrapper">
    <div :class="{ 'fixed-header': fixedHeader }">
      <sidebar class="sidebar-container" />
      <navbar @onDownload="onDownload" :task="downloadTask" />
    </div>
    <div class="main-container">
      <layout-tap />
      <app-main />
    </div>
    <el-dialog
      class="download-dialog"
      v-if="downloadVisible"
      :visible.sync="downloadVisible"
      width="600px"
      :before-close="closeDownload"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('payroll_wage_3')" name="1">
          <ul class="download-list" v-if="downloadTask.list.length">
            <li v-for="(item, index) in downloadTask.list" :key="index" class="download-list-item">
              <div class="dec">
                <h1>
                  <!-- 任务 -->
                  <span>{{ item.name }}</span>
                  <el-tag size="mini" type="warning">{{ item.state_text }}</el-tag>
                </h1>
                <div class="btn"></div>
              </div>
              <div class="info">
                <!-- 操作人 -->
                <span>{{ $t('922') }}：{{ item.staff_name }}</span>
                <span>{{ item.created_at }}</span>
              </div>
            </li>
          </ul>
          <div class="not-data" v-else>
            <img src="@/assets/img/icon-not.png" alt="" />
            <span>{{ $t('not-data') }}</span>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('payroll_wage_31')" name="2">
          <ul class="download-list download-wrap" ref="downloadList" v-if="downloadPendingTask.list.length">
            <li v-for="(item, index) in downloadPendingTask.list" :key="index" class="download-list-item">
              <div class="dec">
                <h1>
                  <!-- 任务 -->
                  <span>{{ item.name }}</span>
                  <el-tag size="mini" v-if="Number(item.state) === 2" type="success">{{ item.state_text }}</el-tag>
                  <el-tag size="mini" v-if="Number(item.state) === 3" type="danger">{{ item.state_text }}</el-tag>
                </h1>
                <div class="btn">
                  <el-button v-if="item.can_download" @click="handleDownload(item)" size="mini" type="text">{{
                    $t('1373')
                  }}</el-button>
                  <el-button v-if="item.relation_type === '1'" @click="handleCheck(item)" size="mini" type="text">{{
                    $t('from_info')
                  }}</el-button>
                </div>
              </div>
              <!-- 3错误 5取消 -->
              <el-button v-if="[3, 5].includes(Number(item.state))" class="error" size="mini" type="text">{{
                item.result
              }}</el-button>
              <div class="info">
                <!-- 操作人 -->
                <span>{{ $t('922') }}：{{ item.staff_name }}</span>
                <span>{{ item.finished_at }}</span>
              </div>
            </li>
          </ul>
          <div class="not-data" v-else>
            <img src="@/assets/img/icon-not.png" alt="" />
            <span>{{ $t('not-data') }}</span>
          </div>
          <Pagination
            v-if="activeName === '2'"
            layout="total, prev, pager, next, jumper"
            :total="downloadPendingTask.total"
            :current-page="downloadPendingTask.page"
            :page-size="downloadPendingTask.page_size"
            @current-change="handleCurrentChange"
          />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { Sidebar, AppMain, Navbar } from './components'
import { mapGetters } from 'vuex'
import Watermark from '@/util/watermark'
import layoutTap from './components/layout-taps'
import Pagination from '@/components/pagination'

import expireDialog from 'util/expire-dialog'
import { getCompletedTaskList, getPendingTaskList } from '@/api/payroll'

export default {
  name: 'Layout',
  components: {
    Sidebar,
    AppMain,
    Navbar,
    layoutTap,
    Pagination
  },
  data() {
    return {
      slideTimeOut: false,
      isShowDia: false,
      downloadVisible: false,
      activeName: '1',
      downloadTask: {
        list: [],
        page: 1,
        page_size: 10
      },
      downloadPendingTask: {
        list: [],
        page: 1,
        total: 0,
        page_size: 10
      },
      baseInfo: this.$s.get('userInfo')
    }
  },
  created() {
    // 获取水印
    if (Number(this.company_info.watermark)) {
      // 是否开启水印
      // eslint-disable-next-line no-new
      new Watermark({
        text: `${this.baseInfo.name} ${this.baseInfo.mobile.slice(-4)}`
      })
    }
  },
  mounted() {
    expireDialog(
      {
        expire_time: this.company_info.expire_time,
        audit_status: this.company_info.audit_status
      },
      this.$t
    )
    this.resetDocumentClientHeight()
    this.initOpend()
  },
  // mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    ...mapGetters(['routes', 'sidebar']),
    isCollapse() {
      return !this.sidebar.opened
    },
    // 计算宽度
    navWidth() {
      return this.classObj.openSidebar ? 216 : 48
    },
    // taps style
    tapsStyle() {
      const { navWidth } = this
      return { left: `${navWidth}px`, width: `calc(100% - ${navWidth}px)` }
    },
    company_info: vm => vm.$store.state.user.company_info
  },
  methods: {
    onDownload() {
      // 异步下载列表
      this.downloadVisible = true
      this.handleClick()
    },
    handleClick() {
      // 进行中 已完成
      if (this.activeName === '1') {
        getPendingTaskList().then(res => {
          if (res && res.code === 1) this.downloadTask.list = res.data
        })
      } else {
        getCompletedTaskList({
          page: this.downloadPendingTask.page,
          page_size: this.downloadPendingTask.page_size
        }).then(res => {
          if (res && res.code === 1) {
            this.downloadPendingTask.list = res.data.data
            this.downloadPendingTask.total = res.data.count
          }
        })
      }
    },
    handleCheck(item) {
      // 查看
      if (item.relation_type === '1') {
        this.$router.push({
          path: '/payroll/wageSalary/' + item.params.sub_id
        })
      }
      this.closeDownload()
    },
    handleDownload(item) {
      // 下载相关内容
      if (item.result && item.result.length) {
        item.result.forEach(url => {
          window.open(url)
        })
      }
    },
    closeDownload() {
      // 关闭下载弹窗
      this.downloadVisible = false
      this.activeName = '1'
      this.downloadPendingTask.page = 1
    },
    handleCurrentChange(val) {
      // 修改分页
      this.$refs.downloadList.scrollTop = 0
      this.downloadPendingTask.page = val
      this.handleClick()
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    resetDocumentClientHeight() {
      this.$store.commit('settings/updateContentViewHeight', window.innerHeight - 170)
      window.addEventListener(
        'resize',
        this.$util.debounce(() => {
          this.$store.commit('settings/updateContentViewHeight', window.innerHeight - 170)
          this.initOpend()
        }, 500)
      )
    },
    // 初始化菜单状态
    initOpend() {
      try {
        const globalWidth = document.body.getBoundingClientRect().width
        this.$store.state.app.sidebar.opened = globalWidth > 1000
      } catch (error) {}
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixin.scss';
@import '~@/assets/styles/variables.scss';
.guide-dialog /deep/ .el-dialog__header {
  display: none;
}
.guide-dialog /deep/ .el-dialog__body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p {
    margin: 11px 0 32px 0;
  }
  .guide-btn {
    margin-bottom: 15px;
  }
}
.img-guide {
  width: 280px;
  height: 280px;
  img {
    width: 100%;
    height: 100%;
  }
  margin: 15px auto;
}
.app-wrapper {
  @include clearfix;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  padding-right: 0;
  top: 0;
  right: 0;
  z-index: 1900;
  width: 100%;
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: 100%;
}

.mobile .fixed-header {
  width: 100%;
}
</style>
